import React from 'react'

import {getEndOffset, useMarginRef} from '../../margin-provider'
import Postcard from '../postcard/Postcard'
import {Props} from '../types'

const PostcardDesktop: React.FC<Props> = ({data}) => {
  const ref = useMarginRef<HTMLDivElement>(getEndOffset)

  return <Postcard ref={ref} data={data} />
}

export default PostcardDesktop
